import {ParamMap} from '@angular/router';
import typia from 'typia';
import {StripeCheckoutReturn} from '../../services/analytics.service';

const isSessionId = typia.createIs<string & typia.tags.Pattern<'^cs_[A-Za-z0-9_]+$'>>();

/**
 * The checkout a success page was reached from, read from the query create-stripe-session puts in
 * Stripe's success URL; undefined without a session id.
 */
export function readStripeCheckoutReturn(query: ParamMap): StripeCheckoutReturn | undefined {
  const sessionId = query.get('session_id');
  if (!isSessionId(sessionId)) {
    return undefined;
  }

  const rawValue = query.get('value');
  const value = rawValue ? Number(rawValue) : NaN;
  return {
    sessionId,
    value: Number.isFinite(value) && value >= 0 ? value : undefined,
    trial: query.get('trial') === 'true',
  };
}
